import type { IsoDate } from '../../../../shared/types';
import type { Snapshot } from '../../data/store';
import { buildToday } from '../../logic/today';
import { section, empty } from '../../ui/components';
import { h } from '../../ui/dom';
import { cardLink } from '../home/cardLink';
import { emptyMirror, type EmptyMirrorOptions } from '../shared/noLeadsYet';

export const agendaCard = () => ({
  render: (snap: Snapshot, today: IsoDate, mirror: EmptyMirrorOptions = {}): HTMLElement => {
    const { overdue, dueToday } = buildToday(snap.leads, snap.visits, today);
    return section({ title: 'Brief', count: overdue.length + dueToday.length,
      action: cardLink('Open Brief', '#/brief') },
      !snap.leads.length ? emptyMirror(mirror) : overdue.length + dueToday.length
        ? h('p', { class: 'card__summary' }, `${overdue.length} overdue · ${dueToday.length} due today`)
        : empty('Nothing waiting — plan a route'),
      cardLink('Plan tomorrow', '#/route/plan'));
  },
  dispose: () => undefined,
});
